
function* request({
  url, method = 'GET', body = '', headers = {}, responseType = 'json', cache,
  onSuccess = () => {}, onError = () => {},
}) {
  let fetchParams = {
    method,
    mode: 'cors',
    credentials: 'same-origin',
    headers,
    redirect: 'follow',
    referrer: 'no-referrer',
    keepalive: true,
  };

  if (cache) fetchParams.cache = cache;

  if (method === 'GET') {
    if (body) {
      url += `?${body}`;
    }
  } else {
    fetchParams.body = body;
  }

  try {
    const response = yield fetch(url, fetchParams);
    let result
    if (responseType === 'blob') {
      result = yield response.blob()
    } else {
      try {
        result = yield response.json();
      } catch (ignore) { /* ignore */ }
    }

    if (response.status !== 200) {
      return yield onError(result);
    }

    return yield onSuccess(result);
  } catch (error) {
    return yield onError(error);
  }
}

export default request
